if (!customElements.get('subscriptions-widget-card')) {
  customElements.define('subscriptions-widget-card', class extends HTMLElement {
    connectedCallback() {
      this.lastSubmittedValue = null;
      this.assignData();
      this.cacheElements();
      this.attachEventListeners();
      this.bindFormVariantChange();
      this.alternateButtonToggle = this.querySelector('.alternate-button-toggle');
      if (this.alternateButtonToggle) {
        this.alternateButtonToggle.addEventListener('click', () => {
          this.optionsContainerToggle();
        });
      }
    }

    assignData() {
      const jsonScript = this.querySelector('script.variant-json');

      if (!jsonScript) {
        console.error('No JSON script tag found');
        this.remove();
        return;
      }

      this.sellingPlan = JSON.parse(jsonScript.textContent || 'null');

      if (!this.sellingPlan) {
        console.error('Selling plan data is empty or invalid');
        this.remove();
        return;
      }
    }

    cacheElements() {
      this.trigger = this.querySelector('.custom-select-trigger');
      this.stockText = this.trigger.dataset.stock;
      this.subscribeText = this.trigger.dataset.subscribe;
      this.optionsContainer = this.querySelector('.custom-options');
      this.sellingPlanRadios = this.querySelectorAll('input[name="selling_plan"]');
      this.hideWhenOOS = this.dataset.hideOos === 'true';
    }

    attachEventListeners() {
      this.trigger.addEventListener('click', () => {
        this.optionsContainerToggle();
      });

      this.sellingPlanRadios.forEach(radio => {
        radio.addEventListener('change', () => {
          const newValue = radio.value;

          if (newValue === this.lastSubmittedValue) {
            // Manually trigger logic again since value didn't change
            this.handleRadioChange(radio);
          } else {
            this.lastSubmittedValue = newValue;
            this.handleRadioChange(radio);
          }
        });
      });


    }

    handleRadioChange(radio) {
      this.closest('vbb-product-form-reactive').querySelector('vbb-reactive-cta button').click();
      radio.checked = false;
    }

    optionsContainerToggle() {
      this.optionsContainer.classList.toggle('hidden');
    }
    bindFormVariantChange() {
      this.productForm = this.closest('vbb-product-form-reactive');
      this.productFormId = this.productForm?.id;

      if (!this.productFormId) {
        console.error('No product form found or id is missing');
        return;
      }

      this.variantDetails = JSON.parse(this.productForm.querySelector(`#variant-details-${this.productFormId}`)?.textContent);

      if(!this.variantDetails) {
        console.error('No variant details found');
        return;
      }

      this.productForm.addEventListener('variant:changed', (event) => {
        const inStock = this.variantDetails.find(variant => variant.variantId === event.detail.variantId)?.inStock;
        if(this.hideWhenOOS) {
          if (!inStock) {
            this.classList.add('hidden');
          } else {
            this.classList.remove('hidden');
          }
        }

        if (inStock) {
          this.trigger.disabled = false;
          this.trigger.innerHTML = this.subscribeText;
        } else {
          this.trigger.disabled = true;
          this.trigger.innerHTML = this.stockText;
        }

      });
    }
  });
}
